<!--suppress JSAnnotator -->
<template>
  <div></div>
</template>

<script>
export default {
  name  : "Product",
  props : {
    "isYellow"          : {
      type    : Number,
      default : 0
    },
    "productId"         : {
      type    : Number,
      default : 0
    },
    "isNew"             : {
      type    : Boolean,
      default : false
    },
    "isInOut"           : {
      type    : Boolean,
      default : false
    },
    "detail"            : {
      type    : Boolean,
      default : false
    },
    "isDiscount"        : {
      type    : Number,
      default : 0
    },
    "isGift"            : {
      type    : Number,
      default : 0
    },
    "discountMinAmount" : {
      type    : Number,
      default : 0
    },
    "discountPercent"   : {
      type    : Number,
      default : 15
    },
    "price"             : {
      type    : Number,
      default : 0
    },
    "storeAvgAmount"    : {
      type    : Number,
      default : 0
    },
    "name"              : {
      type    : String,
      default : ""
    },
    "sectionName"       : {
      type    : String,
      default : ""
    },
    "manufacturer"      : {
      type    : String,
      default : ""
    },
    "priceFormatted"    : {
      type    : String,
      default : ""
    },
    "url"               : {
      type    : String,
      default : ""
    },
    "pic"               : {
      type    : String,
      default : ""
    },
    "isSelected"        : {
      type    : Boolean,
      default : false
    },
    "data"              : {
      type    : Object,
      default : () => ( {} )
    },
    "map"               : {
      type    : Object,
      default : () => ( {} )
    },
    "disabledForOrder"  : {
      type    : Number,
      default : 0
    }
  },
  data  : () => ( {
    isQuantityLimit   : false,
    addedToCart       : false,
    quantity          : 1,
    isYellowPrice     : false,
    priceValue        : 0,
    priceFile         : "",
    averagePriceValue : 0,
    amount            : 0,
    amountMore1       : false,
    availableRegion   : false,
    storeAmount       : 0,
    avgAmount         : 0,
    statusAccordeon   : {
      checkProizvoditel   : false,
      checkCompatibility  : false,
      checkDescription    : false,
      checkCharacteristic : true,
      qualityControl      : false
    }
  } ),
  updated()
    {

    },
  mounted()
    {
      this.priceValue=this.price;
      // if( !this.amount && this.storeAmount )
      //   {
      //     this.amount=+this.storeAmount || 0;
      //   }
      if( this.detail && this.priceValue )
        {
          if( window.dataLayer )
            {
              window.dataLayer.push({
                "ecommerce" : {
                  "detail" : {
                    "products" : [
                      {
                        "id"       : this.productId,
                        "name"     : this.name,
                        "price"    : this.priceValue,
                        "brand"    : this.manufacturer,
                        "category" : this.sectionName,
                        "variant"  : ""
                      }
                    ]
                  }
                }
              });
            }
          $.ajax({
            type : "post",
            url  : "/bitrix/components/bitrix/catalog.element/ajax.php",
            data : {
              AJAX       : "Y",
              SITE_ID    : BX.message("SITE_ID"),
              PRODUCT_ID : this.productId,
              PARENT_ID  : this.productId
            }
          });
        }

      if( $(this.$el).find(".pr_card_images_carousel .pr_card_images_slide").length > 1 )
        {
          $(this.$el).find(".pr_card_images_carousel").slick({
            dots           : false,
            infinite       : true,
            speed          : 600,
            slide          : ".pr_card_images_slide",
            slidesToShow   : 1,
            slidesToScroll : 1,
            // touchMove      : false,
            pauseOnHover   : false,
            prevArrow      : "<button type=\"button\" class=\"slick-prev\"></button>",
            nextArrow      : "<button type=\"button\" class=\"slick-next\"></button>",
            // swipe          : false,
          });
        }
      this.setProdProps();
    },

  computed : {
    availabilityNote()
      {
        let result = {};
        if( this.amount > 1 )
          {
            result = {
              class : "product_item__availability--order-only",
              text  : "Доступно только в магазинах"
            };
          }else{
            result = {
              class : "product_item__availability--order-only",
              text  : "Товара нет в наличии в этом магазине"
            };
        }
        if( this.disabledForOrder )
          {

            result.class="product_item__availability--order-only";
            result.text ="Доступно только в магазинах";
          }
        else if( this.canBuy && this.storeAmount )
          {
            if( this.amount > 1 )
              {

                result.class="product_item__availability--shop-order";
                result.text ="Доступно для заказа и в магазинах";
              }
            else
              {

                result.class="product_item__availability--shop-only";
                result.text ="Доступно только для заказа";
              }
          }
        else
          {

          }
        return result;
      },
    availabilityInfo()
      {
        /*if(+this.amount <= 0){
          return false;
        }*/
        let statuses={
          orderAndShop : {
            class  : "product_item__availability--shop-order",
            text   : "Доступно к заказу и в магазинах",
            button : true,
            showText : false
          },
          onlyShop  : {
            class  : "product_item__availability--shop-only",
            text   : "Доступно только в магазинах",
            button : false,
            showText : true
          },
          orderOnly : {
            class  : "product_item__availability--order-only",
            text   : "Доступно только для заказа",
            button : true,
            showText : false
          },
          notAvailable : {
            class  : "product_item__availability--not-available",
            text   : "Нет в наличии",
            button : false,
            showText : false
          },
          productClose : {
              class  : "product_item__availability--not-available",
              text   : "Товара нет в наличии",
              button : false,
              showText : true
          },
            productCloseRegion : {
                class  : "product_item__availability--not-available",
                text   : "",
                button : false,
                showText : true
            },
            productOpenRegion : {
                class  : "product_item__availability--not-available",
                text   : "",
                button : true,
                showText : true
            }
        };

        if(!this.mainShop.shopNum && +this.amount <= 0){
            if(this.availableRegion == true){
                return statuses.productOpenRegion;
            }else{
                return statuses.productCloseRegion;
            }
        }

        if( this.disabledForOrder )
          {
            //return statuses.onlyShop;
            return statuses.productClose;
          }
        /*amount - наличие в выбранном магазине или магазинах города*/
        /*storeAmount - наличие на складе для выбранного магазина или на складах города*/
        //в магазине есть

        //this.mainShop.shopNum && this.amount < 1 && !this.storeAmount
        if(this.mainShop.shopNum){

           if(+this.amount <= 0){
               return statuses.notAvailable;
           }else
               {

                   if( +this.amount > 0 || +this.storeAmount > 0 )
                       {
                           return statuses.orderAndShop; //Доступно к заказу и в магазинах
                       }
                   else if( +this.storeAmount <= 0 && this.amountMore1 === false )
                       {
                           return statuses.onlyShop; //Доступно только в магазинах
                       }
                   else if( +this.amount == 0 && +this.storeAmount > 0 )
                       {
                           return statuses.orderOnly; //Доступно только для заказа
                       }
                   else
                       {
                           return statuses.notAvailable; //Нет в наличии
                       }
               }
        }else{

          if(+this.amount > 0 || +this.storeAmount > 0){
            return statuses.orderAndShop; //Доступно к заказу и в магазинах
          }else if(+this.storeAmount <= 0 && this.amountMore1!==false){
            return statuses.onlyShop; //Доступно только в магазинах
          }else if(+this.amount == 0 && +this.storeAmount > 0){
            return statuses.orderOnly; //Доступно только для заказа
          }else{
            //return statuses.notAvailable; //Нет в наличии
            return statuses.productClose; //Нет в наличии
          }
        }

        if( +this.amount > 1 )
          {
            return statuses.orderAndShop;
          }
        else
          {
            if( +this.storeAmount > 1 )
              {
                return statuses.orderOnly;
              }
            else
              {
                return statuses.onlyShop;
              }
          }
      },
    showBuyButton()
      {
        return this.availabilityInfo.button;
      },
    productData()
      {
        return this.$store.state.productsData.find(item => +item.product_id === +this.productId);
      },
    isUserAuthorized()
      {
        return !!+this.$store.state.userId;
      },
    canBuy()
      {
        if( this.disabledForOrder > 0 )
          {
            return false;
          }
        if( ~[367803, 1637243].indexOf(+this.productId) )
          {
            return false;
          }
        if(
            this.mainShop.shopNum && this.amount < 1 && !this.storeAmount
        )
          {
            return false;
          }
        return true;
      },
    isDiscountAllowed()
      {
        return false;
        // var isDiscountAllowed = false;
        // if (+this.discountPrice && this.discountMinAmount) {
        //     if (this.quantity >= this.discountMinAmount) {
        //         showHeaderMessage('Применена скидка '+this.discountPercent+'%');
        //         isDiscountAllowed = true;
        //     }
        // }
        // return isDiscountAllowed;
      },
      isPrefixPrice()
        {
            if(this.mainShop && this.mainShop.shopNum){
                return false;
            }
            if(this.productData && this.productData.isPrefixPrice){
                return true;
            }
            return false;
        },
    discountPrice()
      {
        if( !+this.discountPercent || !+this.priceValue )
          {
            return 0;
          }
        return this.priceValue * ( 100 - +this.discountPercent ) / 100;
      },
    favoriteProducts : () => vxCommonStore.state.favoriteProducts,
    mainShop         : () => vxCommonStore.state.mainShop,
    isOrdersDisabled : () => vxCommonStore.state.isOrdersDisabled
  },
  watch    : {
    productData( productData )
      {
        if( !productData )
          {
            return;
          }
        this.setProdProps()
      }
  },
  beforeDestroy () {
    this.$el.parentNode.removeChild(this.$el)
  },
  methods  : {
    setProdProps(){

      if( !this.productData )
        {
          return;
        }
      if( this.productData.priceFile )
        {
          this.priceFile=this.productData.priceFile;
        }
      if( this.productData.price )
        {
          this.priceValue= +this.productData.price;
        }
      if( this.mainShop.shopNum )
        {

          if( this.productData.avgAmount )
            {
              this.avgAmount= +this.productData.avgAmount;
            }
        }
      if( this.productData.is_yellow )
        {
          this.isYellowPrice=true;
        }
      if( this.productData.storeAmount )
        {
          this.storeAmount=+this.productData.storeAmount || 0;
        }
      if( this.productData.amount )
        {
          this.amount=+this.productData.amount || 0;
        }
      if( this.productData.amountMore1 )
        {
          this.amountMore1 = this.productData.amountMore1 || false;
        }
        if( this.productData.availableRegion )
            {
                this.availableRegion = this.productData.availableRegion || false;
            }
      if( this.productData.average_price )
        {
          this.averagePriceValue=this.productData.average_price;
          if( !this.priceValue )
            {
              // this.priceValue=this.productData.average_price;
            }
        }
    },
    favToggle()
      {
        if( !~this.favoriteProducts.indexOf(+this.productId) )
          {
            vxCommonStore.commit("addFavoriteProduct", this.productId);
          }
        else
          {
            vxCommonStore.commit("deleteFavoriteProduct", this.productId);
          }
      },
    favToggleRemove()
    {
      this.$destroy();
      this.favToggle();
    },
    quantityChanged( productId, quantity )
      {
        this.$emit("quantity:changed", productId, quantity);
      },
    showAvailableShops()
      {
        this.$emit("show-available-shops");
      },
    addToEcommerse()
      {
        if( typeof ( addToEcommerse ) == "function" )
          {
            addToEcommerse(this.productId, this.name, this.price, this.manufacturer, this.sectionName, 1);
          }
      },
    getClasses()
      {
        var classes=[];
        classes.push("product");
        // classes.push('product--' + this.productId);
        if( this.addedToCart )
          {
            classes.push("product--addedtocart");
          }
        if( ~vxCommonStore.state.productsInCart.indexOf(this.productId) )
          {
            classes.push("in-cart");
          }
        if( ~this.favoriteProducts.indexOf(this.productId) )
          {
            classes.push("product--favorite");
          }
        if( this.isQuantityLimit )
          {
            classes.push("product--amount-limit");
          }
        if( this.discountPrice )
          {
            classes.push("product--discount");
          }
        if( this.isYellow || this.isYellowPrice )
          {
            classes.push("product--yellow");
          }
        return classes;
      },
    priceMouseOver()
      {
        /*if( this.isYellowPrice || this.isYellow )
          {
            showHeaderMessage("Товары с желтым ценником &ndash; это очень-очень выгодно! Скидка по дисконтной карте не действует.", "yellow", 99999);
          }*/
      },
    priceMouseLeave()
      {
        window.hideHeaderMessageTimer=setTimeout(function()
        {
          hideHeaderMessage();
        }, 3000);
      },
    priceMouseOverNote()
      {
          showHeaderMessage("Это минимальная цена в выбранном вами населенном пункте. Для отображения точной цены выберите магазин.", "yellow", 99999);
          window.hideHeaderMessageTimer=setTimeout(function()
          {
              hideHeaderMessage();
          }, 7000);
      },
    priceMouseLeaveNote()
      {
          window.hideHeaderMessageTimer=setTimeout(function()
          {
              hideHeaderMessage();
          }, 3000);
      },
    giftMouseOver()
      {
        //showHeaderMessage("Товары с желтым ценником &ndash; это очень-очень выгодно! Скидка по дисконтной карте не действует.", "yellow", 99999);
      },
    giftMouseLeave()
      {
        window.hideHeaderMessageTimer=setTimeout(function()
        {
          hideHeaderMessage();
        }, 3000);
      },
      findPriceMouseOver()
          {
              showHeaderMessage("Узнать точную стоимость можно в магазине.", "yellow", 99999);
          },
      findPriceMouseLeave()
          {
              window.hideHeaderMessageTimer=setTimeout(function()
              {
                  hideHeaderMessage();
              }, 3000);
          },
      addToCart()
      {
        if( !this.canBuy )
          {
            return false;
          }
        if( this.isOrdersDisabled )
          {
            vmApp.showOrdersDisabledPopup();
            return false;
          }
        var self         =this;
        var data         ={};
        var arProductInfo=[];
        arProductInfo.push({
          product_id : this.productId,
          quantity   : this.quantity
        });
        data[ "ajax_command" ]="addtocart";
        data[ "PRODUCT" ]     =arProductInfo;
        this.addedToCart      =true;
        XPage.ajax({
          data    : data,
          success : response =>
            {
              if(this.$parent.$refs.basket)
                {
                  this.$parent.$refs.basket.update();
                }
              clearTimeout(this.productAddedTimeout);
              this.productAddedTimeout=setTimeout(
                  () =>
                  {
                    this.addedToCart=false;
                  },
                  3000
              );
              this.addToEcommerse();
              this.$emit("product-added-to-cart");
              if( typeof ( window.yaCounter15466654 ) != "undefined" )
                {
                  window.yaCounter15466654.reachGoal("Cart");
                }
            }
        });
      },
    deleteToProductInCart(){
      let data         ={};
      data[ "ajax_command" ]= "delete_product_in_cart";
      data[ "product_id" ]     = this.productId;
      this.addedToCart      = true;
      XPage.ajax({
        data    : data,
        success : response =>
          {
            if(this.$parent.$refs.basket)
              {
                this.$parent.$refs.basket.update();
              }
            this.$emit("product-added-to-cart");
            clearTimeout(this.productAddedTimeout);
            this.productAddedTimeout=setTimeout(
                () =>
                {
                  this.addedToCart=false;
                },
                3000
            );
          }
      });
    },
    findOutThePrice(){
        this.$parent.$refs.authFormPopup.open();
    },
    openProizvoditel(){
      if(this.statusAccordeon.checkProizvoditel === true){
        this.statusAccordeon.checkProizvoditel = false;
      }
      else
        {
          this.statusAccordeon.checkProizvoditel = true;
          if(this.map.lat && this.map.lng)
            {
              this.$root.initMap(() =>
              {
                ymaps.ready(() =>
                {
                  var productProizvoditelMap=new ymaps.Map("product_proizvoditel_map", {
                    center   : [this.map.lat, this.map.lng],
                    zoom     : 15,
                    controls : ['zoomControl', 'fullscreenControl'],
                  });
                  productProizvoditelMap.behaviors.disable('scrollZoom');
                  productProizvoditelMap.geoObjects.add(new ymaps.Placemark(
                      [this.map.lat, this.map.lng], {}, {
                        iconLayout      : 'default#image',
                        iconImageHref   : this.map.icon,
                        iconImageOffset : [-13, -37],
                        iconImageSize   : [28, 33],
                      }
                  ));
                });
              });
            }
          if(!window.notSlickProizvoditel || window.notSlickProizvoditel!==true)
            {
              $('.product_proizvoditel_slider').slick({
                dots           : false,
                infinite       : true,
                speed          : 600,
                slide          : '.product_compability_slider__item',
                slidesToShow   : 1,
                slidesToScroll : 1,
                touchMove      : false,
                pauseOnHover   : false,
              });
              window.notSlickProizvoditel = true;
            }
        }
    },
    openCompatibility(){

      if(this.statusAccordeon.checkCompatibility === true){
          this.statusAccordeon.checkCompatibility = false;
      }
      else
      {
          this.statusAccordeon.checkCompatibility = true;
        if( typeof ( window.yaCounter15466654 ) != "undefined" )
          {
            window.yaCounter15466654.reachGoal("socheTaemost");
          }
          if(!window.notSlickCompatibility || window.notSlickCompatibility!==true)
            {
              $('.product_compability_slider').slick({
                dots           : false,
                infinite       : true,
                speed          : 600,
                slide          : '.product_compability_slider__item',
                slidesToShow   : 1,
                slidesToScroll : 1,
                touchMove      : false,
                pauseOnHover   : false,
              });
              window.notSlickCompatibility = true;
            }
        }
    },
    openDescription(key){
      if(this.statusAccordeon[key] === true)
        {
          this.statusAccordeon[key] = false;
        }
      else
        {
          this.statusAccordeon[key] = true;
        }
    }
  }
};
</script>